<template>
    <el-autocomplete
      popper-class="my-autocomplete"
      v-model="state"
      :disabled="disabled"
      type="textarea"
      :rows="3"
      :fetch-suggestions="querySearch"
      :placeholder="placeholder"
      style="width:100%"
      :clearable="clearable"
      @change="handleChange"
      @select="handleSelect"
    >
        <template slot-scope="{ item }" v-if="item" >
            <div :class="['name',state.includes(item.value) ? 'selected': '']" >{{ item.value }}</div>
        </template>
    </el-autocomplete>
</template>
<script>
export default {
    name: "Feedback",
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        placeholder: {
            type: String,
            default: "请输入内容",
        },
        value: {
            type: String,
            default: "",
        },
        options: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            optionsList: [],
            confOpts: null,
            cascaderVisiable: true,
            state: this.value,
            isSelect: false
        };
    },
    watch: {
        state(newVal,preVal){
            if(this.isSelect && newVal !== preVal) {
                this.state = preVal + `${ preVal ? ',' : ''}` + newVal
                this.isSelect = false
            }
        },
        value: {
            handler(v) {
                this.state = v
            }
        }
    },
    methods: {
        querySearch(queryString, cb) {
            const result = []
            this.options.forEach(item => {
                if(item.value) result.push(item)
            })
            cb(result);
        },
        //点击方法
        handleSelect(item) {
            console.log(this.state, this.value)
            let count = 0
            this.options.forEach(item => {
                if(item.value && this.value.includes(item.value)) count++
            })
            if(count >= 3){
                this.$message.warning('最多支持选择3条！')
                this.state = this.value
                return
            }
            this.isSelect = true
            this.$nextTick(() => {
                this.$emit('input', this.state)
                this.$emit('change', this.state)
            })
        },
        handleChange(val) {
            this.$emit('input', val)
            this.$emit('change', val)
        },
    },
};
</script>
<style lang="less">
.my-autocomplete {
    li {
        line-height: normal;
        padding: 7px;
        .name {
            text-overflow: ellipsis;
            overflow: hidden;
        }
        .selected {
            color: #409eff;
        }
    }
}
</style>